var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M11,10H5L3,8L5,6H11V3L12,2L13,3V4H19L21,6L19,8H13V10H19L21,12L19,14H13V20A2,2 0 0,1 15,22H9A2,2 0 0,1 11,20V10Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }